"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
ProfileService.$inject = ['api', 'extApi', 'Popeye', '$q'];
function ProfileService(api, extApi, Popeye, $q) {
    var service = {};
    service.get = function () {
        return api.get('/b2b/profile2');
    };
    service.saveUser = function (data) {
        return api.update('/b2b/profile2', data);
    };
    service.updateAddresses = function (addresses) {
        return api.post('/b2b/company/addresses', addresses.items);
    };
    service.saveAddress = function (address) {
        if (address.address_id) {
            return extApi.put('/delivery-addresses/' + address.address_id, address);
        }
        else {
            return extApi.post('/delivery-addresses', address);
        }
    };
    service.removeAddress = function (address) {
        var delay = $q.defer();
        Popeye.openModal({
            templateUrl: "../scripts/apps/profile/views/remove-address.html",
            modalClass: 'remove',
            controller: ['$scope', 'notify', function ($scope, notify) {
                    $scope.cancel = function (err) {
                        delay.reject(err);
                    };
                    $scope.ok = function (response) {
                        delay.resolve(response);
                        Popeye.closeCurrentModal(response);
                    };
                    $scope.confirm = function () {
                        return extApi.remove('/delivery-addresses/' + address.address_id).then(function (response) {
                            $scope.ok(response);
                        });
                    };
                }]
        });
        return delay.promise;
    };
    service.addAddressModal = function () {
        var delay = $q.defer();
        var modal = Popeye.openModal({
            template: require('../views/modal-add-address.html'),
            containerClass: 'modal-priority',
            modalClass: 'add-address-modal',
            controller: ['$scope', function ($scope) {
                    $scope.address = {
                        is_default: false,
                        address: '',
                        city: '',
                        contact_phone: '',
                        contact_person: ''
                    };
                    $scope.cancel = function (err) {
                        delay.reject(err);
                    };
                    $scope.ok = function (response) {
                        delay.resolve(response);
                        Popeye.closeCurrentModal(response);
                    };
                    $scope.add = function () {
                        extApi.post('/delivery-addresses', $scope.address)
                            .then(function (response) {
                            $scope.ok(response);
                        });
                    };
                }]
        });
        modal.closed.then(function () {
            delay.reject();
        });
        return delay.promise;
    };
    return service;
}
exports.ProfileService = ProfileService;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/profile/services/profile.js
// module id = 438
// module chunks = 0